import PermissionsCustomView from "../../../gd/access-control/permissions/custom-view"
import {ViewType} from "../../../gd/const/views/view-type"
import {NavigationSectionType} from "../../navigation/@const"
import {QuickAddItemType} from "../../../../app/quick-add/@types"
import {
    AddView_Group,
    AddView_GroupEvents, AddView_GroupProject,
    AddView_GroupTasks,
    AddView_GroupType
} from "../../../gd-ui/add-view/@types";
import {PROJECT_CALENDAR_CONFIG} from "../../../views/calendar/@config"
import {CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG} from "../../../views/events-summary/@config"
import {CUSTOM_VIEW_EXPENSES_CONFIG} from "../../../views/expenses/@config-custom"
import {PROJECT_GANTT_CONFIG} from "../../../views/gantt/@config"
import {Feature} from "../../../gd/access-control/feature-access/const";
import {PROJECT_WORKLOAD_CONFIG} from "../../../views/workload/@config"
import {PROJECT_ACTIVITY_CONFIG} from "../../../views/activity/@config"
import {CUSTOM_VIEW_WHATS_DONE_CONFIG} from "../../../views/whats-done/@config"
import {
    CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG
} from "../../../gd/const/views/configs/custom/custom-view-external-data-glist";
import {CUSTOM_VIEW_PASTDUE_CONFIG} from "../../../views/pastdue/@config";
import {CUSTOM_VIEW_PRIORITIES_CONFIG} from "../../../views/priorities/@config";
import {CUSTOM_VIEW_ACTION_REQUIRED_CONFIG} from "../../../views/action-required/@config";
import {CUSTOM_VIEW_TASKS_BY_USER_CONFIG} from "../../../views/tasks-by-user/@config";
import {PROJECTS_PORTFOLIO_CONFIG} from "../../../views/portfolio/@config";
import {PROJECTS_PROJECTS_LIST_CONFIG} from "../../../views/projects-list/@config";
import {PROJECT_TIMELINE_CONFIG} from "../../../gd/const/views/configs/project-timeline";
import {AddView_TaskBoard, AddView_TaskList, AddView_TaskTable} from "../../../gd-ui/add-view/@config"
import {addViewCheckAccess} from "./check-access";

type Options = {
    navigationSectionType?  : NavigationSectionType
    // projectId?              : ID
}

// const debug = "NewView_getViewsStructure"
const debug = false


// THIS IS USED FOR CUSTOM VIEWS CREATION
// i.e. HOME or PROJECTS

export default function NewView_NewCustomViewStructure(options:Options={}) {

    debug && console.log(debug, 'process', options)

    const params = {
        location        : options.navigationSectionType
    }

    let structure: AddView_Group[] = []

    // TASKS
    structure.push({
        ...AddView_GroupTasks,
        items       : [
            {
                ...AddView_TaskList,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.VIEW, {...params, type: ViewType.PROJECT_LIST})
                }
            },
            {
                ...AddView_TaskTable,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.VIEW, {...params, type: ViewType.PROJECT_TABLE})
                }
            },
            {
                ...AddView_TaskBoard,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.VIEW, {...params, type: ViewType.PROJECT_BOARD})
                }
            },
        ]
    })

    // EVENTS
    structure.push({
        ...AddView_GroupEvents,
        items       : [
            {
                typeId          : ViewType.PROJECT_CALENDAR,
                iconSvg         : PROJECT_CALENDAR_CONFIG.iconSvg,
                title           : PROJECT_CALENDAR_CONFIG.name,
                description     : PROJECT_CALENDAR_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.PROJECT_CALENDAR, location: options.navigationSectionType})
                }
            },
            {
                typeId          : ViewType.PROJECT_TIMELINE,
                iconSvg         : PROJECT_TIMELINE_CONFIG.iconSvg,
                title           : PROJECT_TIMELINE_CONFIG.name,
                description     : PROJECT_TIMELINE_CONFIG.description,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.VIEW, {type: ViewType.PROJECT_TIMELINE, location: options.navigationSectionType})
                }
            },
            {
                typeId          : ViewType.CUSTOM_VIEW_EVENTS_SUMMARY,
                iconSvg         : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.name,
                description     : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_EVENTS_SUMMARY, location: options.navigationSectionType})
                }
            },
        ],
    })

    // Planning
    structure.push({
        type        : AddView_GroupType.GROUP,
        id          : 'planning',
        icon        : 'i5-gantchart2',
        title       : 'Planning',
        items       : [
            {
                typeId          : ViewType.PROJECT_GANTT,
                iconSvg         : PROJECT_GANTT_CONFIG.iconSvg,
                title           : PROJECT_GANTT_CONFIG.name,
                description     : PROJECT_GANTT_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_GANTT),
                proFeature      : Feature.GANTT,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.VIEW, {type: ViewType.PROJECT_GANTT, location: options.navigationSectionType})
                }
            },
            {
                typeId          : ViewType.PROJECT_WORKLOAD,
                iconSvg         : PROJECT_WORKLOAD_CONFIG.iconSvg,
                title           : PROJECT_WORKLOAD_CONFIG.name,
                description     : PROJECT_WORKLOAD_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_WORKLOAD),
                proFeature      : Feature.WORKLOAD,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.VIEW, {type: ViewType.PROJECT_WORKLOAD, location: options.navigationSectionType})
                }
            },
        ],
    })

    // PROJECTS
    structure.push({
        ...AddView_GroupProject,
        items       : [
            {
                typeId          : ViewType.PROJECTS_PORTFOLIO,
                iconSvg         : PROJECTS_PORTFOLIO_CONFIG.iconSvg,
                title           : PROJECTS_PORTFOLIO_CONFIG.name,
                description     : PROJECTS_PORTFOLIO_CONFIG.description,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.PORTFOLIO, {type: ViewType.PROJECTS_PORTFOLIO, location: options.navigationSectionType})
                }
            },
            {
                typeId          : ViewType.PROJECTS_PROJECTS_LIST,
                iconSvg         : PROJECTS_PROJECTS_LIST_CONFIG.iconSvg,
                title           : PROJECTS_PROJECTS_LIST_CONFIG.name,
                description     : PROJECTS_PROJECTS_LIST_CONFIG.description,
                onClick         : async () => {
                    gd.openNew(QuickAddItemType.PORTFOLIO, {type: ViewType.PROJECTS_PROJECTS_LIST, location: options.navigationSectionType})
                }
            },
        ],
    })



    // Progress and reports
    structure.push(        {
        type        : AddView_GroupType.GROUP,
        id          : 'progress',
        icon        : 'i5-chart-bar',
        title       : 'Progress & Reports',
        items       : [
            {
                typeId          : ViewType.PROJECT_ACTIVITY,
                iconSvg         : PROJECT_ACTIVITY_CONFIG.iconSvg,
                title           : PROJECT_ACTIVITY_CONFIG.name,
                description     : PROJECT_ACTIVITY_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.PROJECT_ACTIVITY, location: options.navigationSectionType})
                }
            },

            {
                typeId          : ViewType.CUSTOM_VIEW_WHATS_DONE,
                iconSvg         : CUSTOM_VIEW_WHATS_DONE_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_WHATS_DONE_CONFIG.name,
                description     : CUSTOM_VIEW_WHATS_DONE_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_WHATS_DONE, location: options.navigationSectionType})
                }
            },

            {
                typeId          : ViewType.CUSTOM_VIEW_PASTDUE,
                iconSvg         : CUSTOM_VIEW_PASTDUE_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_PASTDUE_CONFIG.name,
                description     : CUSTOM_VIEW_PASTDUE_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_PASTDUE, location: options.navigationSectionType})
                }
            },

            {
                typeId          : ViewType.CUSTOM_VIEW_PRIORITIES,
                iconSvg         : CUSTOM_VIEW_PRIORITIES_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_PRIORITIES_CONFIG.name,
                description     : CUSTOM_VIEW_PRIORITIES_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_PRIORITIES, location: options.navigationSectionType})
                }
            },

            {
                typeId          : ViewType.CUSTOM_VIEW_ACTION_REQUIRED,
                iconSvg         : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.name,
                description     : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_ACTION_REQUIRED, location: options.navigationSectionType})
                }
            },

            {
                typeId          : ViewType.CUSTOM_VIEW_TASKS_BY_USER,
                iconSvg         : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.name,
                description     : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_TASKS_BY_USER, location: options.navigationSectionType})
                }
            },

            gd.modules.customEntities.enabled ? {
                typeId          : ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST,
                iconSvg         : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG.name,
                description     : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST, location: options.navigationSectionType})
                }
            } : null

        ],
    })

    // FINANCE
    structure.push({
        id          : 'finance',
        type        : AddView_GroupType.GROUP,
        icon        : 'i5-expenses-light',
        title       : 'Finance',
        items       : [

            gd.modules.expenses.enabled ? {
                typeId          : ViewType.CUSTOM_VIEW_EXPENSES,
                iconSvg         : CUSTOM_VIEW_EXPENSES_CONFIG.iconSvg,
                title           : CUSTOM_VIEW_EXPENSES_CONFIG.name,
                description     : CUSTOM_VIEW_EXPENSES_CONFIG.description,
                onClick         : async () => {
                    gd.openNew('view', {type: ViewType.CUSTOM_VIEW_EXPENSES, location: options.navigationSectionType})
                }
            } : null

        ]
    })

    // DASHBOARDS
    structure.push({
        type        : AddView_GroupType.GROUP,
        id          : 'dashboard',
        icon        : 'i5-dashboard',
        title       : 'Dashboard',
        skipItemsList   : true,
        items       : [
            {
                typeId          : 'from-scratch',
                iconSvg         : 'isvg-view-dashboard',
                title           : 'From scratch',
                description     : 'Create dashboard from scratch',
                onClick         : () => {


                    gd.openNew(QuickAddItemType.DASHBOARD, {
                        location: gd.layout.navigation.state.currentSection?.space?.id === gd.spaces.projects.id ? 'projects': undefined
                    })

                    // createCustomDashboard({
                    //     templateId      : 'empty',
                    //     name            : 'Create from scratch',
                    //     description     : 'Create a personalized dashboard from scratch.',
                    //     preview         : 'add-custom-dashboard.svg',
                    //     dashboardType   : DashboardType.CUSTOM,
                    //     configFunction  : ()=>{}
                    // }, {
                    //     location: gd.layout.navigation.state.currentSection?.space?.id === gd.spaces.projects.id ? 'projects': undefined
                    // })
                }
            },
            // {
            //     typeId          : 'from-template',
            //     iconSvg         : 'isvg-view-dashboard',
            //     title           : 'From template',
            //     description     : 'Create dashboard from template',
            //     onClick         : () => {
            //         gd.openNew(QuickAddItemType.DASHBOARD, {
            //             location: gd.layout.navigation.state.currentSection?.space?.id === gd.spaces.projects.id ? 'projects': undefined
            //         })
            //     }
            // }
        ]
    })





    // FILTER with access check
    return addViewCheckAccess(structure)

}
